module.exports = __webpack_public_path__ + "img/search.eef11e8.svg";